import pxToRem from "../../functions/pxToRem";

const icon = {

};

export default icon;
